import { CompleteInsightModal } from "../Common/Modals/CompleteInsightModal";
import { INSIGHT_CATEGORY } from "../../Types/account";
import {
  TUTORIAL_DEMO_INSIGHTS,
  TUTORIAL_SCENARIO,
} from "../../Constants/tutorialScenario";
import "../../Css/Common/Modals/GlassModal.css";

type TutorialDemoCompleteInsightModalProps = {
  onClose?: () => void;
};

/** Real CompleteInsightModal shell for the App Guide (no-op submit). */
export function TutorialDemoCompleteInsightModal({
  onClose,
}: TutorialDemoCompleteInsightModalProps) {
  const handleClose = onClose ?? (() => {});

  return (
    <div className="tutorialDemoOverlay_backdrop" aria-hidden={false}>
      <div
        className="tutorialDemoOverlay_insightModalShell"
        data-tour="insight-complete-modal"
        onClick={(e) => e.stopPropagation()}
      >
        <CompleteInsightModal
          insightId={TUTORIAL_DEMO_INSIGHTS[0].id}
          insightType={INSIGHT_CATEGORY.ACCOUNT}
          accountId={TUTORIAL_SCENARIO.primaryAccount.uuid}
          clientId={null}
          onClose={handleClose}
          onComplete={() => {}}
        />
      </div>
    </div>
  );
}
